//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isUsingNewLayout } from '~/utils/isUsingNewLayout'
import getHearingJourney from '~/gql/getHearingJourney'

import proseText from '~/mixins/proseText'

export default {
  mixins: [proseText],
  inheritAttrs: false,
  props: {
    carouselItems: {
      type: Array,
      default() {},
    },
  },

  data() {
    return {
      currentIndex: 0,
      details: false,
      detailTitle: null,
      detailText: null,
      detailEmbeds: [],
      localCarouselItems: [...this.carouselItems],
    }
  },

  async fetch() {
    const { articles } = await this.$graphcms.request(getHearingJourney, {
      id: this.carouselItems[this.currentIndex].id,
      lang: [this.$i18n.locale],
      assetLocales: [this.$i18n.locale, this.$i18n.defaultLocale],
    })
    const article = articles[0]
    this.detailTitle = article.title
    this.detailText = article.content.html
    this.detailEmbeds = article.content.references
  },

  computed: {
    isUsingNewLayout() {
      return isUsingNewLayout(this.$i18n.locale)
    },
  },

  watch: {
    id(newId, oldId) {
      this.$fetch()
    },
  },

  mounted() {
    this.localCarouselItems = this.carouselItems
    if (isUsingNewLayout(this.$i18n.locale)) {
      this.localCarouselItems = this.carouselItems.filter(
        (item) => item.carouselHearingJourney !== null
      )
      this.localCarouselItems = this.localCarouselItems
        .map((item) => item.carouselHearingJourney)
        .flat()
    }
    this.$emit('ready')
  },

  methods: {
    handleItemClick(index) {
      this.currentIndex = index
      this.$fetch()
      if (window.innerWidth <= 602) {
        this.scrollToContent()
      }
    },

    showDetails() {
      this.$fetch()
      this.details = true
    },

    hideDetails() {
      this.details = false
    },

    nextStep() {
      if (this.currentIndex === this.localCarouselItems.length - 1) {
        this.currentIndex = 0
        this.$fetch()
      } else {
        this.currentIndex = this.currentIndex + 1
        this.$fetch()
      }
    },

    extractFirstH2Text(html) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      const h2Element = doc.querySelector('h2')

      return h2Element ? h2Element.textContent : ''
    },

    scrollToContent() {
      const newHearingContent = this.$refs.new_hearing_content
      if (newHearingContent) {
        const yOffset =
          newHearingContent.getBoundingClientRect().top + window.scrollY - 80
        window.scrollTo({ top: yOffset, behavior: 'smooth' })
      }
    },
  },
}
